import { takeLatest, call, put, all, select } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import history from '~/services/history';
import api from '~/services/api';
import * as actions from './actions';
import * as types from './types';
import { alertLogoSuccess } from '~/pages/CadastroInstituicao/messages';

/**
 * ---------------------------------------------------
 *  CATEGORIAS DA INSTITUIÇÃO
 * ---------------------------------------------------
 */

export function* listCategories() {
  try {
    const response = yield call(api.get, 'instituicoes/categorias');

    yield put(
      actions.listCategoriesSuccess({
        categoriesInstituitions: response.data,
      })
    );
  } catch (error) {
    yield put(actions.listCategoriesFailure());
  }
}

/**
 * ---------------------------------------------------
 *  CADASTRO DE INSTITUIÇÃO
 * ---------------------------------------------------
 */

export function* newInstitution({ payload }) {
  const { data, image, idEdition } = payload;

  try {
    let response;
    if (idEdition) {
      response = yield call(api.put, `/instituicoes/${idEdition}`, data);
      toast.success('Instituição atualizada com sucesso.');
    } else {
      response = yield call(api.post, 'instituicoes', data);
      toast.success('Instituição cadastrada com sucesso.');
    }

    yield put(
      actions.newInstitutionSuccess({
        instituitionData: response.data,
      })
    );

    const { id, fantasyName, ativo } = response.data;

    if (image)
      yield put(
        actions.uploadLogoRequest({
          image,
          id,
        })
      );

    if (idEdition && ativo) {
      setTimeout(() => {
        history.push({
          pathname: '/administrador/selecao-das-linhas-de-cuidado',
          state: { id: idEdition },
        });
      }, 800);

      return;
    }

    if (idEdition) {
      setTimeout(() => {
        history.push({
          pathname: '/administrador/instituicoes-participantes',
        });
      }, 800);

      return;
    }
    setTimeout(() => {
      history.push({
        pathname: '/administrador/novo-usuario',
        state: {
          idInstituicao: id,
          nomeFantasia: fantasyName,
          accessLevel: 'ROLE_MANAGER',
        },
      });
    }, 800);
  } catch (error) {
    yield put(actions.newInstitutionFailure());

    if (error?.response && error?.response?.data?.fields?.length) {
      Swal.fire({
        title: 'Atenção',
        text: `${String(
          error.response.data?.fields[0]?.parameter + ': ' || ''
        ).toUpperCase()}${error.response.data?.fields[0]?.exception ||
          error.response.data.error}`,
        icon: 'error',
        confirmButtonColor: '#74a50a',
      });
    } else {
      Swal.fire({
        title: `${error?.response?.data?.error}`,
        text: `Tente novamente ou entre em contato com a equipe de suporte do sistema.`,
        icon: 'error',
        confirmButtonColor: '#74a50a',
      });
    }
  }
}

export function* uploadLogo({ payload }) {
  const { roles } = yield select(state => state.auth);

  const ROLE_ADMIN = roles.includes('ROLE_ADMIN');

  const { id, image } = payload;

  const imageLogo = new FormData();
  imageLogo.append('file', image);

  const { institutionId } = yield select(state => state.auth);
  try {
    yield call(
      api.put,
      `instituicoes/${ROLE_ADMIN ? id : institutionId}/upload-logo-tipo`,
      imageLogo,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    if (!ROLE_ADMIN) Swal.fire(alertLogoSuccess);

    yield put(actions.uploadLogoSuccess());
  } catch (error) {
    toast.error('Não foi possível atualizar o logotipo da instituição', {
      autoClose: 6000,
    });
    yield put(actions.uploadLogoFailure());
  }
}

/**
 * ---------------------------------------------------
 *  GET INSTITUIÇÃO POR ID
 * ---------------------------------------------------
 */

export function* getInstitution({ payload }) {
  const { roles } = yield select(state => state.auth);

  const ROLE_ADMIN = roles.includes('ROLE_ADMIN');

  const { id } = payload;
  try {
    let response;
    if (ROLE_ADMIN) {
      response = yield call(api.get, `instituicoes/${id}`);
    } else {
      response = yield call(api.get, `/instituicoes/${id}/dados-instituicao`);
    }

    yield put(
      actions.getInstitutionSuccess({
        instituitionData: response.data,
      })
    );
  } catch (error) {
    yield put(actions.getInstitutionFailure());
  }
}

/**
 * ---------------------------------------------------
 *  GET INSTITUIÇÕES PARTICIPANTES
 * ---------------------------------------------------
 */

export function* getInstitutions({ payload }) {
  const { orderBy = '', offset = '', search = '', direction = 'asc' } = payload;

  let order = orderBy || '';
  let filter = search || '';

  try {
    const response = yield call(
      api.get,
      `instituicoes?limit=5${filter && `&filter=${filter}`}&offset=${offset ||
        0}${order && `&orderBy=${order}&direction=${direction}`}`
    );

    const totalCount = response.headers['total-count'];

    yield put(
      actions.getInstitutionsSuccess({
        instituitionsData: {
          data: response.data,
          totalCount,
        },
        instituitionsOrderBy: order,
        instituitionsSearch: search,
      })
    );
  } catch (error) {
    yield put(actions.getInstitutionsFailure());
  }
}

export function setToken({ payload }) {
  if (!payload) return;

  const { token } = payload.auth;

  if (token) {
    api.defaults.headers.Authorization = `${token}`;
  }
}

export default all([
  takeLatest('persist/REHYDRATE', setToken),
  takeLatest(types.LIST_CATEGORIES_REQUEST, listCategories),
  takeLatest(types.NEW_INSTITUTION_REQUEST, newInstitution),
  takeLatest(types.LOGO_INSTITUTION_REQUEST, uploadLogo),
  takeLatest(types.GET_INSTITUTION_REQUEST, getInstitution),
  takeLatest(types.GET_INSTITUTIONS_REQUEST, getInstitutions),
]);
